<template>
  <div
    class="profile-badge-wrapper"
    :class="className"
    v-if="
      data.tier &&
      data.tier.image.resourceUri &&
      data.tier.image.resourceUri.length > 0
    "
  >
    <img :src="data.tier.image.resourceUri" alt="badge-image" class="profile-badge-image" />
  </div>
</template>

<script>
export default {
  name: "ProfileTier",
  props: ["data", "className"],
};
</script>

<style scoped>
.profile-badge-wrapper {
  position: absolute;
  width: 24px;
  height: 24px;
  z-index: 2;
  right: -3px;
  bottom: -3px;
  background: #fff;
  border-radius: 50%;
  border: 0.5px solid #fff;
  overflow: hidden;
}

.profile-badge-image {
  width: 100%;
	height: 100%;
	object-fit: cover;
}

.size-18 {
  width: 18px !important;
  height: 18px !important;
  right: -3px;
  bottom: -3px;
}
</style>